import { render, staticRenderFns } from "./UtilImgBackground.vue?vue&type=template&id=ce5bcabe&scoped=true"
import script from "./UtilImgBackground.vue?vue&type=script&lang=js"
export * from "./UtilImgBackground.vue?vue&type=script&lang=js"
import style0 from "./UtilImgBackground.vue?vue&type=style&index=0&id=ce5bcabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5bcabe",
  null
  
)

export default component.exports